import React from "react";

const About = () => {
  return (
    <div>
      <h1
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        Acerca de nosotros
      </h1>
      <p style={{ textAlign: "center" }}>
        El Grupo de Beach Tennis Medellín es una comunidad apasionada por este
        El Tenis Playa El Tenis Playa es una disciplina que nace en Italia en
        los años 70 con el juego del "racchettoni", con palas de madera
        convencionales, pero es en 1996 cuando nace el verdadero Tenis Playa con
        los campos de 16×8 m. con una red a 170 cm de altura. Esto fue gracias a
        que a principios de los años 80 la gente comenzó a jugar dentro de los
        campos de Vóley Playa bajando la red, el juego era más rápido y vistoso,
        por lo que comenzó a crecer en popularidad. Esto llevo a que los dueños
        de los clubes de Vóley Playa promovieran el Tenis Playa para ofrecer a
        sus clientes una actividad atractiva. Si bien su crecimiento nunca se
        detuvo, fue en la década del 2000 que explotó a nivel mundial, en
        especial a partir del año 2008 cuando la Federación Internacional de
        Tenis (ITF) asumió la responsabilidad y el desarrollo del Beach Tennis
        Tour en todo el mundo. En la actualidad se practica en muchos países,
        entre ellos Italia, Alemania, España, Brasil, Portugal, Japón, San
        Marino, Turquía, Bulgaria, Australia, Bélgica, Austria, Chipre, Croacia,
        Estados Unidos, Francia, Grecia, Holanda, República Checa, Rusia,
        Venezuela, Ecuador, Chile, Aruba, Argentina, entre otros. Este gran
        crecimiento ha llevado a la ITF a gestionar la inclusión del Tenis Playa
        como nuevo deporte Olímpico, basándose en el precedente del Vóley Playa.
        “El Tenis Playa en Colombia se practica hace poco menos de tres años
        (2017), inició en Cartagena, luego en Bogotá, continua el proyecto, a
        mediados de 2018 en Guadalajara de Buga y Medellín, Pereira, Santa
        Marta, Cali 2019 y Barranquilla 2020. Esperamos este 2023 crecer en 20
        ciudades más con capacitaciones y exhibiciones de la disciplina….”
      </p>
      <h1
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        Horarios
      </h1>
      <img
        src="/images/LuisSchedule.jpeg"
        alt="Horarios de clases"
        style={{
          display: "block",
          margin: "0 auto",
          maxWidth: "100%",
          height: "auto"
        }}
      />
      <h1
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        Ubicaciones
      </h1>
      <p style={{ textAlign: "center" }}>
        Estadio: Contamos con canchas disponibles en el estadio de la ciudad
        para la práctica de beach tennis.
        <br /> {/* Salto de línea */}
        Unidad Deportiva Andrés Escobar: Disfruta de nuestras instalaciones en
        la Unidad Deportiva Andrés Escobar, equipadas para el beach tennis.
        <br /> {/* Salto de línea */}
        Unidad Deportiva Belén Rincón: También ofrecemos espacios en la Unidad
        Deportiva Belén Rincón, ideales para jugar beach tennis.
      </p>
    </div>
  );
};

export default About;
